import { REACT_APP_ENV } from '@/react-process-env';
import { IEditorType, ImageEditorPath } from '@/types';

export const isDevelopEnv = function () {
    return REACT_APP_ENV === 'development';
};

export const isPreEnv = function () {
    return REACT_APP_ENV === 'pre';
};

export const isBetaEnv = function () {
    return REACT_APP_ENV === 'beta';
};

export const isReleaseEnv = function () {
    return REACT_APP_ENV === 'release';
};

export const getPrefix = function () {
    return isDevelopEnv() ? '' : 'design/';
};

export const getHostPrefix = function () {
    return isReleaseEnv() ? 'www' : isDevelopEnv() ? '' : REACT_APP_ENV;
};

export function getServerEnv(env = REACT_APP_ENV) {
    switch (env) {
        case 'development':
        case 'pre':
            return 'pre';
        case 'beta':
            return 'beta';
        case 'production':
        case 'release':
            return 'release';
        default:
            return 'release';
    }
}

/**
 * 获取主机域名
 *
 * @param editorType - 获取实际编辑地址时传入目标编辑器类型
 */
export const getHostname = function (editorType?: IEditorType) {
    const isImageEditor = editorType === IEditorType.imageEditor;
    return `${window.location.origin}${isImageEditor ? ImageEditorPath : isDevelopEnv() ? '' : '/design'}`;
};
